import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=c90d2d90"
import script from "./typeList.vue?vue&type=script&lang=js"
export * from "./typeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports